var App = App || {};

App.SiteLogin = (function ($) {
    "use strict";


    function init() {
        LoginFormSelector();
        SkipToOnlineBanking();
    }

    function LoginFormSelector() {
        $("#loginFormSelector").on("change", function (e) {
            var $optionSelected = $("option:selected", this);
            $($optionSelected.data('target')).show().siblings().hide();
        });
    }

    function SkipToOnlineBanking() {
        var $skiptoOlbBtn = $('#skip-to-onlinebanking');
        var $olbBtn = $('#olbBtn');

        $skiptoOlbBtn.on('click', function () {
            $olbBtn.trigger('click');
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SiteLogin.init();
});